import { useQuery } from "@tanstack/react-query";

import { apiFetch, buildParams } from "@/lib/api";
import type { AvailablePillarsOutput } from "@/types";

interface UseAvailablePillarsParams {
  role: string;
}

export function useAvailablePillars(params: UseAvailablePillarsParams) {
  const query = buildParams({ role: params.role });

  return useQuery({
    queryKey: ["available-pillars", params],
    queryFn: () => apiFetch<AvailablePillarsOutput>(`/v1/home/available-pillars${query}`),
    enabled: !!params.role,
  });
}
